/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';

class CheckboxLayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date()
        };
    }
    componentDidMount() {

    }
    onChange(evt) {
        console.log('check-button',this.props.selectdata, evt.target.checked)
        this
            .props
            .onselectChanges({ id: this.props.selectdata.id, name: this.props.selectdata.name,value: this.props.selectdata.text, parrentMode: this.props.selectdata.task_id, parrentName: this.props.selectdata.parrentName, parentID: this.props.selectdata.parent_id });
  };

    render() {
        
        return (
            <React.Fragment>
                <input
                style={{transform: 'scale(2)'}}
                    type="checkbox"
                    id={this.props.selectdata.text+this.props.selectdata.task_id} 
                    name={this.props.selectdata.task_id} 
                    value="" 
                    checked={this.props.selectdata.value == this.props.selectdata.text ? true : false}
                    onChange={evt => this.onChange(evt)}
                    disabled={this.props.selectdata.disable} />
                    {/* <label for={this.props.selectdata.text+this.props.selectdata.task_id}>{this.props.selectdata.text}</label> */}
            </React.Fragment>
        );
    }
}

export default CheckboxLayer;